import { render, staticRenderFns } from "./FooterCustomerSupport.vue?vue&type=template&id=7b1b4a15&"
import script from "./FooterCustomerSupport.vue?vue&type=script&lang=js&"
export * from "./FooterCustomerSupport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports